import React from 'react';
import { Box, Button, Divider, TextField, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

const CarReg = ({ customisations, form, setForm, setStatus, clearForm }) => {
   const [carReg, setCarReg] = React.useState(() => {
      if (form?.carReg !== undefined) {
         return form.carReg;
      }
      return '';
   });

   async function saveReg() {
      setForm({ ...form, carReg });
      if (customisations?.contactNumber) {
         setStatus('contactNumber');
      } else {
         setStatus('step2');
      }
   }
   async function goBack() {
      setStatus('step1');
   }

   return (
      <Box sx={{ width: '100%' }}>
         <Typography variant="h5" align="center">
            Car Parking
         </Typography>
         <Typography variant="body1" align="center">
            If you have used our car park, please enter your registration number.
         </Typography>
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               gap: 3,
               mb: 3,
               justifyContent: 'space-between',
               width: '100%',
               mt: 1,
            }}
         >
            <Box sx={{ width: '15%', mt: 2 }}>
               <Button
                  onClick={() => {
                     goBack();
                  }}
                  sx={{ height: '130px' }}
                  fullWidth
                  variant="outlined"
                  color="primary"
               >
                  Back
               </Button>
            </Box>
            <Box sx={{ minWidth: '70%', flexDirection: 'column' }}>
               <TextField
                  value={carReg}
                  onChange={(e) => setCarReg(e.target.value)}
                  label="Car Registration"
                  variant="outlined"
                  margin="normal"
                  fullWidth
               />
            </Box>

            <Box sx={{ width: '15%', mt: 2, display: 'flex', alignItems: 'flex-start' }}>
               <Button
                  onClick={() => saveReg()}
                  variant="contained"
                  fullWidth
                  sx={{ height: '130px' }}
                  color="primary"
               >
                  {carReg === '' ? 'Skip' : 'Next'}
               </Button>
            </Box>
         </Box>
         <Divider sx={{ width: '100%' }} />
         <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Button
               onClick={() => clearForm()}
               startIcon={<ReplayIcon />}
               color="primary"
            >
               Start again
            </Button>
         </Box>
      </Box>
   );
};

export default CarReg;
